import React, { useEffect, useState } from 'react'
import PickupServiceApprovedImage from './Assets/ApprovedPickupService.png';
import pickupsteps from "./Assets/illustration.svg";
import { useNavigate } from "react-router-dom";
import {  UpdateStudentPickupServiceOffersStatus } from '../../Actions/CourseA';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

const PickupServiceApproved = ({UserId, formattedDate, hoursAgo, Offers, Message,
     EnrollmentId, formattedApprovedDate, ApprovedhoursAgo, CreatedDisplayTime}) => {
    const navigate = useNavigate();
    const Dispatch = useDispatch()

    const handleRedirect = () => {
        navigate("/inbox"); // Redirect to /inbox
      };
    
    const handleAction = (action) => {
        Dispatch(UpdateStudentPickupServiceOffersStatus(UserId,action,EnrollmentId))
        .then(() => {
            // Set a timeout to refresh the page after 5 seconds
            setTimeout(() => {
                window.location.reload();
            }, 5000);

        })
    };

    let displayTime;
    if (ApprovedhoursAgo === null) {
        displayTime = "N/A";
    } else if (ApprovedhoursAgo < 24) {
        displayTime = `${ApprovedhoursAgo} hours ago`;
    } else if (ApprovedhoursAgo < 168) { // 7 days = 168 hours
        const daysAgo = Math.floor(ApprovedhoursAgo / 24);
        displayTime = `${daysAgo} day${daysAgo > 1 ? 's' : ''} ago`;
    } else {
        const weeksAgo = Math.floor(ApprovedhoursAgo / 168);
        displayTime = `${weeksAgo} week${weeksAgo > 1 ? 's' : ''} ago`;
    }
    
    return (
        <>
            <div className='w-full'>
                <div className='flex flex-col justify-center items-center'>
                    <img src={PickupServiceApprovedImage} alt="pickup image" className='w-[300px] h-[300px] lg:w-[400px] lg:h-[400px] mt-[-10px]' />
                    <p className='font-bold text-[24px] lg:text-[28px] text-center w-[320px] lg:w-[650px] text-[#4C34AD] mt-[-20px]'>Pickup service is activated. If you want to change Pickup Location contact with staff.</p>
                    <p className='text-[16px] lg:text-[18px] text-center w-[320px] lg:w-[600px] mt-[15px]'>
                    In order to change the address of pickup Location, Contact with the driving school staff to provide you a new offer with your updated Location.
                    </p>

                    <div className='flex justify-center items-center gap-[10px] lg:gap-[15px] mt-[30px]'>
                        <button className={`w-[150px] lg:w-[180px] h-[40px] text-[14px] lg:text-[16px] text-center rounded-[10px] bg-[#4C34AD] text-[#FFFFFF] font-bold`}
                        onClick={handleRedirect}
                        >
                            Chat with Staff
                        </button>
                    </div>

                    <div className="w-full flex justify-center items-center mt-[50px]">
                        <div className='w-[75%] flex flex-col px-[40px] py-[20px] shadow-[4px_5px_6px_#00000029] rounded-[10px]'
                        style={{
                            border:"1px solid #BCBCBC"
                        }}>
                        <p className='text-[24px] text-[#4C34AD] font-bold'>My Offers</p>
                        <div className='w-full flex justify-between mt-[30px]'>
                            <div className='flex flex-col'>
                                <p className='text-[20px] text-[#4C34AD] font-bold'>Date</p>
                                <p className='text-[16px] text-[#4C34AD] mt-[15px]'>Initiated {formattedDate}</p>
                                <p className='text-[14px] text-[#4C34AD] mt-[5px]'>{CreatedDisplayTime}</p>
                            </div>

                            <div className='flex flex-col'>
                                <p className='text-[20px] text-[#4C34AD] font-bold'>Offer</p>
                                <p className='text-[16px] text-[#4C34AD] mt-[15px]'>{Offers} $</p>
                            </div>

                            <div className='flex flex-col'>
                                <p className='text-[20px] text-[#4C34AD] font-bold'>Message</p>
                                <p className='text-[16px] text-[#4C34AD] mt-[15px] w-[350px]'>{Message}</p>
                            </div>
                            <div className='flex flex-col mt-[-10px] py-[10px] px-[20px] rounded-[8px] mr-[40px]'
                                    style={{
                                            border:"1px solid #4C34AD"
                                        }}>
                                <p className='text-[16px] text-[#4C34AD] mt-[15px]'>Approved on {formattedApprovedDate}</p>
                                <p className='text-[14px] text-[#4C34AD] mt-[5px]'>{displayTime}</p>
                            </div>
                        </div>

                        </div>
                    </div>

                    <div className='flex justify-center items-center gap-[10px] lg:gap-[15px] mt-[30px]'>
                        <button className={`w-[150px] lg:w-[180px] h-[40px] text-[14px] lg:text-[16px] text-center rounded-[10px] bg-[#4C34AD] text-[#FFFFFF] font-bold`}
                        onClick={() => handleAction("Activated")}
                        >
                            Done
                        </button>
                    </div>

                    <p className='font-bold text-[24px] lg:text-[28px] text-center w-[320px] lg:w-[500px] text-[#4C34AD] mt-[50px]'>How it Works?</p>

                    <div className="w-full flex justify-center items-center mt-[30px]">
                        <div className='w-[75%] flex flex-col lg:flex-row justify-between items-center'>
                            <div className="flex justify-center items-center">
                                <img src={pickupsteps} alt="pickup image" className='' />
                                <p className='text-[16px] lg:text-[18px] w-[200px] ml-[-5px]'>If you did not received any offer for pickup, you can ask Driving staff to send you an offer.</p>
                            </div>

                            <div className="flex justify-center items-center">
                                <img src={pickupsteps} alt="pickup image" className='' />
                                <p className='text-[16px] lg:text-[18px] w-[200px] ml-[-5px]'>You can Reject the offer if you think the offer is high and you can ask the staff to resend new offer.</p>
                            </div>

                            <div className="flex justify-center items-center">
                                <img src={pickupsteps} alt="pickup image" className='' />
                                <p className='text-[16px] lg:text-[18px] w-[200px] ml-[-5px]'>Once the offer is approved the pickup service will be activated further.</p>
                            </div>
                        </div>
                    </div>
            </div>
            </div>
        </>
    )
}

export default PickupServiceApproved